import React from "react";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import Logotipo from "@assets/company/Logotipo.svg";
import LogotipoMinifiedColor from "@assets/company/LogotipoMinifiedColor.svg";
import LogotipoMinifiedWhite from "@assets/company/LogotipoMinifiedWhite.svg";
// endregion Imports - Assets
// region Imports - Helpers
import utils from "@helpers/utils";
// endregion Imports - Helpers

interface ExternalSvgProps {
  svgName: "Logotipo" | "LogotipoMinifiedColor" | "LogotipoMinifiedWhite"
  className?: string;
}

const ExternalSvg: React.FC<ExternalSvgProps> = ({ svgName, className }) => {

  // region Constants
  const externalSvgPath = `${utils.getBackendBaseUrl(false)}/visual/${svgName}.svg`;
  // endregion Constants
  // region Functions
  const getFallbackSvgPath = () : string => {

    switch (svgName) {
      case "Logotipo":
        return Logotipo;
      case "LogotipoMinifiedColor":
        return LogotipoMinifiedWhite;
      case "LogotipoMinifiedWhite":
        return LogotipoMinifiedColor;
      default:
        return "";
    }
  };

  const getFallbackComponent = () => (
    <ReactSVG
      src={getFallbackSvgPath()}
      alt="Client Logo"
      className={className}
    />
  );
  // endregion Functions

  return (
    <ReactSVG
      src={externalSvgPath}
      alt="Client Logo"
      className={className}
      fallback={getFallbackComponent}
    />
  );
};

ExternalSvg.defaultProps = {
  className: undefined
};

export default ExternalSvg;
